module.exports = __webpack_public_path__ + "img/app_qr_code.f64c44af.svg";